import React from 'react';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    number: 1,
    title: 'Plan PRO 90 - Entrenamientos según tu nivel',
    value: '$14.990'
  }, {
    number: 2,
    title: '30 Jugadas preparadas para partidos de pádel',
    value: '$9.990'
  }, {
    number: 3,
    title: 'Manual Anti-Rivales — Domina estilos de juego específicos y vence a los rivales',
    value: '$12.990'
  }];
  return <section className="w-full bg-black py-16 px-4" data-id="element-14">
      <div className="max-w-5xl mx-auto" data-id="element-15">
        <div className="flex items-center justify-center gap-3 mb-4" data-id="element-16">
          <Gift className="w-8 h-8 text-[#C6FF3C]" data-id="element-17" />
          <h2 className="headline-font text-4xl md:text-5xl text-center text-white uppercase" data-id="element-18">
            Bonos <span className="text-[#C6FF3C]" data-id="element-19">Gratis</span> Por Hoy
          </h2>
        </div>

        <div className="flex justify-center mb-8" data-id="element-20">
          <span className="inline-block px-6 py-2 bg-red-600 text-white font-bold text-sm uppercase rounded-full" data-id="element-21">
            🔥 Solo por tiempo limitado
          </span>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-22">
          {bonuses.map(bonus => <div key={bonus.number} onClick={scrollToCompra} className="bg-gradient-to-br from-gray-900 to-black border-2 border-[#C6FF3C] rounded-lg p-6 cursor-pointer hover:scale-105 transition-transform duration-300" data-id="element-23">
              <div className="bg-[#C6FF3C] text-black font-bold text-lg px-4 py-2 rounded inline-block mb-4" data-id="element-24">
                BONO #{bonus.number}
              </div>
              <h3 className="text-white font-bold text-lg mb-4 min-h-[60px]" data-id="element-25">
                {bonus.title}
              </h3>
              <div className="border-t border-gray-700 pt-4" data-id="element-26">
                <p className="text-gray-400 text-sm line-through mb-1" data-id="element-27">
                  VALOR {bonus.value}
                </p>
                <p className="text-[#C6FF3C] font-bold text-xl" data-id="element-28">HOY GRATIS</p>
              </div>
            </div>)}
        </div>

        <div className="bg-[#C6FF3C] text-black rounded-lg p-6 text-center" data-id="element-29">
          <p className="text-2xl md:text-3xl font-bold" data-id="element-30">
            TOTAL EN BONOS: <span className="line-through" data-id="element-31">$37.970</span>
          </p>
          <p className="text-3xl md:text-4xl font-bold mt-2" data-id="element-32">GRATIS HOY</p>
        </div>
      </div>
    </section>;
}